export default __webpack_public_path__ + "static/media/GR00038-online_education.33b980f9.svg";